export default {
      id: "arrow-right-usage",
      viewBox: "0 0 738 251",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }